import { InstructionType } from './MedicationModels';
export function isDaaInstruction(instruction) {
    if (instruction === null)
        return false;
    return instruction.type === InstructionType.DaaInstruction;
}
export function isFreeTextInstruction(instruction) {
    if (instruction === null)
        return false;
    return instruction.type === InstructionType.FreeTextInstruction;
}
export function isDosageTimesInstruction(instruction) {
    if (instruction === null)
        return false;
    return instruction.type === InstructionType.DosageTimeInstruction;
}
